export const C_REALESTATE_TYPES_IDS = {
  APARTMENT: 1,
  HOUSE: 2,
  COMERCIAL_SITE: 3,
  INDUSTRIAL_SITE: 4,
  ESTATE: 5,
  LAND: 6,
  BUSINESS: 7,
  BUILDING: 8,
  TURISTIC: 9,
  HOTEL: 10,
  HOUSE_OR_LAND: 12,
  BUILDING_OR_LAND: 13,
  PROJECT: 14,
  PENTHOUSE: 15,
  GAS_STATION: 16,
  OFFICE_SITE: 17
};

export const C_REALESTATE_TYPES = {
  APARTMENT: {
    id: C_REALESTATE_TYPES_IDS.APARTMENT,
    name: "Apartamento",
    value: "apartment",
    label: "Apartamento"
  },
  HOUSE: {
    id: C_REALESTATE_TYPES_IDS.HOUSE,
    name: "Casa",
    value: "house",
    label: "Casa"
  },
  PROJECT: {
    id: C_REALESTATE_TYPES_IDS.PROJECT,
    name: "Proyectos",
    value: "project",
    label: "Proyectos"
  },
  COMERCIAL_SITE: {
    id: C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    name: "Local Comercial",
    value: "comercial site",
    label: "Local comercial"
  },
  INDUSTRIAL_SITE: {
    id: C_REALESTATE_TYPES_IDS.INDUSTRIAL_SITE,
    name: "Nave Industrial",
    value: "industrial site",
    label: "Nave industrial"
  },
  ESTATE: {
    id: C_REALESTATE_TYPES_IDS.ESTATE,
    name: "Finca",
    value: "estate",
    label: "Finca"
  },
  LAND: {
    id: C_REALESTATE_TYPES_IDS.LAND,
    name: "Terreno",
    value: "land",
    label: "Terreno"
  },
  OFFICE: {
    id: C_REALESTATE_TYPES_IDS.BUSINESS,
    name: "Negocio",
    value: "office",
    label: "Negocio"
  },
  BUILDING: {
    id: C_REALESTATE_TYPES_IDS.BUILDING,
    name: "Edificio",
    value: "building",
    label: "Edificio"
  },
  TURISTIC: {
    id: C_REALESTATE_TYPES_IDS.TURISTIC,
    name: "Turistico",
    value: "turistic",
    label: "Turístico"
  },
  HOTEL: {
    id: C_REALESTATE_TYPES_IDS.HOTEL,
    name: "Hotel",
    value: "hotel",
    label: "Hotel"
  },
  HOUSE_OR_LAND: {
    id: C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    name: "Casa o solar",
    value: "house or land",
    label: "Casa o solar"
  },
  BUILDING_OR_LAND: {
    id: C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    name: "Edificio o solar",
    value: "building or land",
    label: "Edificio o solar"
  },
  OFFICE_SITE: {
    id: C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    name: "Local de oficina",
    value: "office site",
    label: "Local de oficina"
  },
  PENTHOUSE: {
    id: C_REALESTATE_TYPES_IDS.PENTHOUSE,
    name: "Penthouse",
    value: "penthouse",
    label: "Penthouse"
  },
  GAS_STATION: {
    id: C_REALESTATE_TYPES_IDS.GAS_STATION,
    name: "Estación de combustible",
    value: "gasstation",
    label: "Estación de combustible"
  }
};

export const C_REALESTATE_TYPES_PROJECT = {
  APARTMENT: C_REALESTATE_TYPES.APARTMENT,
  HOUSE: C_REALESTATE_TYPES.HOUSE,
  COMERCIAL_SITE: C_REALESTATE_TYPES.COMERCIAL_SITE,
  INDUSTRIAL_SITE: { ...C_REALESTATE_TYPES.INDUSTRIAL_SITE, id: 5 },
  LAND: C_REALESTATE_TYPES.LAND
};

export const A_PROPERTY_TYPES_FOR_PROJECT = [
  C_REALESTATE_TYPES_PROJECT.APARTMENT,
  C_REALESTATE_TYPES_PROJECT.HOUSE,
  C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE,
  C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE,
  C_REALESTATE_TYPES_PROJECT.LAND
];

export const A_REALESTATE_TYPES = [
  C_REALESTATE_TYPES.APARTMENT,
  C_REALESTATE_TYPES.HOUSE,
  C_REALESTATE_TYPES.PROJECT,
  C_REALESTATE_TYPES.COMERCIAL_SITE,
  C_REALESTATE_TYPES.INDUSTRIAL_SITE,
  C_REALESTATE_TYPES.ESTATE,
  C_REALESTATE_TYPES.LAND,
  C_REALESTATE_TYPES.OFFICE,
  C_REALESTATE_TYPES.BUILDING,
  C_REALESTATE_TYPES.TURISTIC,
  C_REALESTATE_TYPES.HOTEL,
  C_REALESTATE_TYPES.HOUSE_OR_LAND,
  C_REALESTATE_TYPES.BUILDING_OR_LAND,
  C_REALESTATE_TYPES.OFFICE_SITE,
  C_REALESTATE_TYPES.PENTHOUSE,
  C_REALESTATE_TYPES.GAS_STATION
];

// export const A_REALESTATE_TYPES_FOR_PROPERTY = [
//   C_REALESTATE_TYPES.APARTMENT,
//   C_REALESTATE_TYPES.HOUSE,
//   C_REALESTATE_TYPES.COMERCIAL_SITE,
//   C_REALESTATE_TYPES.INDUSTRIAL_SITE,
//   C_REALESTATE_TYPES.ESTATE,
//   C_REALESTATE_TYPES.LAND,
//   C_REALESTATE_TYPES.OFFICE,
//   C_REALESTATE_TYPES.BUILDING,
//   C_REALESTATE_TYPES.TURISTIC,
//   C_REALESTATE_TYPES.HOTEL,
//   C_REALESTATE_TYPES.OFFICE_SITE,
//   C_REALESTATE_TYPES.PENTHOUSE,
//   C_REALESTATE_TYPES.GAS_STATION
// ];
export const A_REALESTATE_TYPES_PROJECT = [
  C_REALESTATE_TYPES.APARTMENT,
  C_REALESTATE_TYPES.HOUSE,
  C_REALESTATE_TYPES.PROJECT,
  C_REALESTATE_TYPES.COMERCIAL_SITE,
  C_REALESTATE_TYPES.INDUSTRIAL_SITE,
  C_REALESTATE_TYPES.ESTATE,
  C_REALESTATE_TYPES.LAND,
  C_REALESTATE_TYPES.OFFICE,
  C_REALESTATE_TYPES.BUILDING,
  C_REALESTATE_TYPES.TURISTIC,
  C_REALESTATE_TYPES.HOTEL,
  C_REALESTATE_TYPES.HOUSE_OR_LAND,
  C_REALESTATE_TYPES.BUILDING_OR_LAND,
  C_REALESTATE_TYPES.OFFICE_SITE,
  C_REALESTATE_TYPES.PENTHOUSE,
  C_REALESTATE_TYPES.GAS_STATION
];

export const O_REALESTATE_TYPES = {
  [C_REALESTATE_TYPES_IDS.APARTMENT]: C_REALESTATE_TYPES.APARTMENT,
  [C_REALESTATE_TYPES_IDS.HOUSE]: C_REALESTATE_TYPES.HOUSE,
  [C_REALESTATE_TYPES_IDS.PROJECT]: C_REALESTATE_TYPES.PROJECT,
  [C_REALESTATE_TYPES_IDS.COMERCIAL_SITE]: C_REALESTATE_TYPES.COMERCIAL_SITE,
  [C_REALESTATE_TYPES_IDS.INDUSTRIAL_SITE]: C_REALESTATE_TYPES.INDUSTRIAL_SITE,
  [C_REALESTATE_TYPES_IDS.ESTATE]: C_REALESTATE_TYPES.ESTATE,
  [C_REALESTATE_TYPES_IDS.LAND]: C_REALESTATE_TYPES.LAND,
  [C_REALESTATE_TYPES_IDS.BUSINESS]: C_REALESTATE_TYPES.OFFICE,
  [C_REALESTATE_TYPES_IDS.BUILDING]: C_REALESTATE_TYPES.BUILDING,
  [C_REALESTATE_TYPES_IDS.TURISTIC]: C_REALESTATE_TYPES.TURISTIC,
  [C_REALESTATE_TYPES_IDS.HOTEL]: C_REALESTATE_TYPES.HOTEL,
  [C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND]: C_REALESTATE_TYPES.HOUSE_OR_LAND,
  [C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND]: C_REALESTATE_TYPES.BUILDING_OR_LAND,
  [C_REALESTATE_TYPES_IDS.OFFICE_SITE]: C_REALESTATE_TYPES.OFFICE_SITE,
  [C_REALESTATE_TYPES_IDS.PENTHOUSE]: C_REALESTATE_TYPES.PENTHOUSE,
  [C_REALESTATE_TYPES_IDS.GAS_STATION]: C_REALESTATE_TYPES.GAS_STATION,

  //names

  [C_REALESTATE_TYPES.APARTMENT.name]: C_REALESTATE_TYPES.APARTMENT,
  [C_REALESTATE_TYPES.HOUSE.name]: C_REALESTATE_TYPES.HOUSE,
  [C_REALESTATE_TYPES.PROJECT.name]: C_REALESTATE_TYPES.PROJECT,
  [C_REALESTATE_TYPES.COMERCIAL_SITE.name]: C_REALESTATE_TYPES.COMERCIAL_SITE,
  [C_REALESTATE_TYPES.INDUSTRIAL_SITE.name]: C_REALESTATE_TYPES.INDUSTRIAL_SITE,
  [C_REALESTATE_TYPES.ESTATE.name]: C_REALESTATE_TYPES.ESTATE,
  [C_REALESTATE_TYPES.LAND.name]: C_REALESTATE_TYPES.LAND,
  [C_REALESTATE_TYPES.OFFICE.name]: C_REALESTATE_TYPES.OFFICE,
  [C_REALESTATE_TYPES.BUILDING.name]: C_REALESTATE_TYPES.BUILDING,
  [C_REALESTATE_TYPES.TURISTIC.name]: C_REALESTATE_TYPES.TURISTIC,
  [C_REALESTATE_TYPES.HOTEL.name]: C_REALESTATE_TYPES.HOTEL,
  [C_REALESTATE_TYPES.HOUSE_OR_LAND.name]: C_REALESTATE_TYPES.HOUSE_OR_LAND,
  [C_REALESTATE_TYPES.BUILDING_OR_LAND.name]: C_REALESTATE_TYPES.BUILDING_OR_LAND,
  [C_REALESTATE_TYPES.OFFICE_SITE.name]: C_REALESTATE_TYPES.OFFICE_SITE,
  [C_REALESTATE_TYPES.PENTHOUSE.name]: C_REALESTATE_TYPES.PENTHOUSE,

  //values

  [C_REALESTATE_TYPES.APARTMENT.value]: C_REALESTATE_TYPES.APARTMENT,
  [C_REALESTATE_TYPES.HOUSE.value]: C_REALESTATE_TYPES.HOUSE,
  [C_REALESTATE_TYPES.PROJECT.value]: C_REALESTATE_TYPES.PROJECT,
  [C_REALESTATE_TYPES.COMERCIAL_SITE.value]: C_REALESTATE_TYPES.COMERCIAL_SITE,
  [C_REALESTATE_TYPES.INDUSTRIAL_SITE.value]: C_REALESTATE_TYPES.INDUSTRIAL_SITE,
  [C_REALESTATE_TYPES.ESTATE.value]: C_REALESTATE_TYPES.ESTATE,
  [C_REALESTATE_TYPES.LAND.value]: C_REALESTATE_TYPES.LAND,
  [C_REALESTATE_TYPES.OFFICE.value]: C_REALESTATE_TYPES.OFFICE,
  [C_REALESTATE_TYPES.BUILDING.value]: C_REALESTATE_TYPES.BUILDING,
  [C_REALESTATE_TYPES.TURISTIC.value]: C_REALESTATE_TYPES.TURISTIC,
  [C_REALESTATE_TYPES.HOTEL.value]: C_REALESTATE_TYPES.HOTEL,
  [C_REALESTATE_TYPES.HOUSE_OR_LAND.value]: C_REALESTATE_TYPES.HOUSE_OR_LAND,
  [C_REALESTATE_TYPES.BUILDING_OR_LAND.value]: C_REALESTATE_TYPES.BUILDING_OR_LAND,
  [C_REALESTATE_TYPES.OFFICE_SITE.value]: C_REALESTATE_TYPES.OFFICE_SITE,
  [C_REALESTATE_TYPES.PENTHOUSE.value]: C_REALESTATE_TYPES.PENTHOUSE
};

export const O_REALESTATE_TYPES_PROJECT = {
  [C_REALESTATE_TYPES_PROJECT.APARTMENT.name]: C_REALESTATE_TYPES_PROJECT.APARTMENT,
  [C_REALESTATE_TYPES_PROJECT.HOUSE.name]: C_REALESTATE_TYPES_PROJECT.HOUSE,
  [C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.name]:
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE,
  [C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.name]:
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE,
  [C_REALESTATE_TYPES_PROJECT.LAND.name]: C_REALESTATE_TYPES_PROJECT.LAND,

  //values
  [C_REALESTATE_TYPES_PROJECT.APARTMENT.value]: C_REALESTATE_TYPES_PROJECT.APARTMENT,
  [C_REALESTATE_TYPES_PROJECT.HOUSE.value]: C_REALESTATE_TYPES_PROJECT.HOUSE,
  [C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.value]:
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE,
  [C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.value]:
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE,
  [C_REALESTATE_TYPES_PROJECT.LAND.value]: C_REALESTATE_TYPES_PROJECT.LAND,

  // id

  [C_REALESTATE_TYPES_PROJECT.APARTMENT.id]: C_REALESTATE_TYPES_PROJECT.APARTMENT,
  [C_REALESTATE_TYPES_PROJECT.HOUSE.id]: C_REALESTATE_TYPES_PROJECT.HOUSE,
  [C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id]:
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE,
  [C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id]:
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE,
  [C_REALESTATE_TYPES_PROJECT.LAND.id]: C_REALESTATE_TYPES_PROJECT.LAND
};
// type
export interface IRealestateType {
  id: number;
  name: string;
  value: string;
  label: string;
}
